// The ONE copy source for the post-checkout surfaces. Previously triplicated as
// WAIVER_REASON_COPY (BookingForm, SessionBookingForm) and REASON_RETRY
// (GuestWaiver), which had already drifted.

/** Server-side rejection reasons the form normally prevents, but which can
 *  still surface (a clock-split at an exact birthday boundary, a second device
 *  taking the slot, or a direct action call). Actionable copy, never a bare
 *  "try again". Calm accents — inform, don't alarm. */
export const WAIVER_REASON_COPY: Record<string, string> = {
  under_min: 'This rider doesn’t meet the minimum age for this activity — please double-check the date of birth.',
  minor_not_allowed: 'This dealer can only sign riders 18 and older. Please talk to your dealer.',
  guardian_incomplete: 'A parent or guardian needs to complete and sign for this rider — please check the date of birth.',
  invalid_dob: 'Please check the date of birth and try again.',
  invalid_email: 'Please check the email address and try again.',
  no_terms_published: 'Your dealer is finishing setup — you’ll sign your waiver at pickup.',
  slot_taken: 'That rider already signed — pick a different rider.',
  already_signed: 'That rider already signed — pick a different rider.',
  slot_required: 'Pick which rider is signing first.',
}

/** Calm, full-screen states for the durable token pages. A link that's expired
 *  or invalid is informational, never an error to be alarmed by. */
export const PAGE_STATE_MESSAGES: Record<string, { title: string; body: string }> = {
  all_signed: { title: 'All set', body: 'Show this to your dealer to pick up your efoil.' },
  expired: { title: 'This link expired', body: 'Ask your dealer for a new one.' },
  revoked: { title: 'This booking changed', body: 'Contact your dealer to continue.' },
  invalid: { title: "This link isn't valid", body: 'Double-check the link your dealer sent you.' },
  not_confirmed: { title: "Your booking isn't ready yet", body: 'Once your dealer confirms it, this page will be ready.' },
  not_paid: { title: "Your booking isn't ready yet", body: 'Once payment is complete, this page will be ready.' },
  no_terms_published: { title: 'Almost ready', body: 'Your dealer is finishing setup. Check back shortly to sign.' },
}
